import React from 'react';
import { withRouter } from 'react-router-dom';
import AddService from '../component-add-service';

class AddServicePage extends React.Component {
    render() {
        return (
            <AddService
                appearance={ this.props.location.state.appearance }
            />
        );
    }
}

export default withRouter(AddServicePage);


// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/containers/container-add-service.js